import DataSourceDropdown from '@/components/ui/data-source/DataSourceDropdown'
import Dropdown from '@/components/ui/dropdown/Dropdown'
import { ToolbarDivider } from '@/components/ui/list-page/ListPageToolbar'
import { useCanSelectDataSource } from '@/hooks'
import { ASSET_MAP_TIMESCALE_READY } from '@/types/data-source'

import { useMapControls } from './hooks/useMapControls'
import { useMapContext } from './MapContext'
import type { TopNavMapControlsProps } from './types'

/** The data source (when selectable) and company pickers, for the page's top row. */
export const CompanyControls = ({ mapRef }: TopNavMapControlsProps) => {
  const { dataSource, setDataSource } = useMapContext()
  const canSelectDataSource = useCanSelectDataSource()
  const controls = useMapControls(mapRef)

  return (
    <div className="md:flex hidden items-center w-fit gap-4">
      {canSelectDataSource && ASSET_MAP_TIMESCALE_READY && (
        <>
          <div className="flex items-center gap-2 shrink-0">
            <span className="text-xs opacity-70">Data Source:</span>
            <div className="w-36">
              <DataSourceDropdown id="mapDataSource" value={dataSource} onChange={setDataSource} />
            </div>
          </div>
          <ToolbarDivider />
        </>
      )}

      {(controls.isLoadingCompanies || controls.companies.length > 0) && (
        <div className="flex items-center gap-2 shrink-0">
          <div className="w-[23rem]">
            <Dropdown
              options={controls.companyOptions}
              selectedItem={controls.selectedCompanyOption}
              handleSingleSelectItem={controls.handleCompanyChange}
              placeholder={controls.isLoadingCompanies ? 'Loading...' : 'Choose a company...'}
            />
          </div>
        </div>
      )}
    </div>
  )
}
